// removed by extract-text-webpack-plugin
module.exports = {"contentDescription":"_2agYO87OlvjUJvztIunYAl","contentDetails":"_1vbyI_IDdVxcpr2NoPAEp1","relatedProjectsRow":"_21WxhN7s7GJNqK28cM3X5J","relatedProjectsTitle":"_1d1dAzg1Evbsh-hzm8nbIy"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/content/Content.css
// module id = 392
// module chunks = 0